import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PermissionTypes } from 'helper/products';

export type ProductKeys = {
  [key in PermissionTypes]: string | null
};

const initialState: ProductKeys = {
  'file-viewer': null,
  flux: null,
  'flux-videos': null,
  meteorologia: null,
  'meteorologia-videos': null,
  'prevs-personalizado': null,
  'prevs-automatico': null,
  'prevs-historico': null,
  'prevs-gt': null,
  agro: null,
  windx: null,
  relatorios: null,
};

interface ProductKeyPayload {
  product: PermissionTypes,
  key: string | null,
}

export const productKeySlice = createSlice({
  name: 'productKeys',
  initialState,
  reducers: {
    setProductKey: (state, action: PayloadAction<ProductKeyPayload>) => {
      const { product, key } = action.payload;
      state[product] = key;
    },
  },
});

export const { setProductKey } = productKeySlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectProductKeys = (state: any): ProductKeys => state.productKeys;

export default productKeySlice.reducer;
